import { IconButton, MenuItem } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Clear from "@material-ui/icons/Clear";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DeviceSearchAutocomplete from "../../../../Components/DeviceSearchAutocomplete";
import Title from "../../../../Components/Title";

export default function DeviceSection({ unedited, emaillist, setEmailList }) {
  unedited = unedited || emaillist;
  const { t } = useTranslation();
  const [resetKey, setResetKey] = useState("sdfasfsda");

  return (
    <Grid item sm={3} xs={12}>
      <Title>{t("emailLists.devices")}</Title>
      {unedited &&
        unedited.EmailListDevices &&
        unedited.EmailListDevices.map((u, i) =>
          u && u.Device ? (
            <MenuItem
              key={i}
              style={
                emaillist.EmailListDevices.find(
                  (uu) => uu.Device.serialNumber === u.Device.serialNumber
                )
                  ? {}
                  : { textDecoration: "line-through" }
              }
            >
              {u.Device.serialNumber}
              <IconButton
                style={{ position: "absolute", right: 0 }}
                onClick={() => {
                  setEmailList({
                    ...emaillist,
                    EmailListDevices: emaillist.EmailListDevices.filter(
                      (f) => f.Device?.id !== u.Device?.id
                    ),
                  });
                }}
              >
                <Clear />
              </IconButton>
            </MenuItem>
          ) : null
        )}
      {emaillist &&
        unedited &&
        emaillist.EmailListDevices &&
        emaillist.EmailListDevices.filter(
          (u) =>
            !unedited.EmailListDevices.find(
              (f) => u.Device?.id === f.Device?.id
            )
        ).map((u, i) => (
          <MenuItem
            key={i}
            style={{
              backgroundColor: "rgb(177 255 184)",
            }}
          >
            {u.Device.serialNumber}
            <IconButton
              style={{ position: "absolute", right: 0 }}
              onClick={() => {
                setEmailList({
                  ...emaillist,
                  EmailListDevices: emaillist.EmailListDevices.filter(
                    (f) => f.Device.id !== u.Device.id
                  ),
                });
              }}
            >
              <Clear />
            </IconButton>
          </MenuItem>
        ))}
      <DeviceSearchAutocomplete
        style={{ marginTop: 5 }}
        key={resetKey}
        label={t("emailLists.searchDevice")}
        onChange={(e, v) => {
          if (!v || !v.serialNumber) {
            return;
          }
          setEmailList({
            ...emaillist,
            EmailListDevices: [
              ...(emaillist?.EmailListDevices || []),
              { Device: v },
            ],
          });
          setResetKey(new Date().toISOString());
        }}
      />
    </Grid>
  );
}
